import React from "react";
import "./style.css";
import { NavHashLink as Link } from "react-router-hash-link";
import Sidebar from "../sidebar";

class Navibar extends React.Component {
  render() {
    var navibarCss = "navibar";

    const scrollWidthOffset = (el) => {
      const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
      const yOffset = -60;
      window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
    };

    return (
      <div className={navibarCss}>
        {/* <SwitchComponent
          handleChange={this.props.handleChange}
          checked={this.props.checked}
        /> */}
        <Sidebar />

        <div className="navibar-items">
          <Link
            activeClassName="home-link active"
            scroll={(el) => scrollWidthOffset(el)}
            to="/#home"
            className="home-link"
          >
            Home
          </Link>

          <Link
            activeClassName="about-link active"
            scroll={(el) => scrollWidthOffset(el)}
            to="/#about"
            className="about-link"
          >
            About
          </Link>

          <Link
            activeClassName="projects-link active"
            scroll={(el) => scrollWidthOffset(el)}
            to="/#projects"
            className="projects-link"
          >
            My work
          </Link>
          <Link
            activeClassName="contact-link active"
            scroll={(el) => scrollWidthOffset(el)}
            to="/#contact"
            className="contact-link"
          >
            Contact
          </Link>
        </div>
      </div>
    );
  }
}
export default Navibar;
